import script from "./ragister_simple.vue?vue&type=script&setup=true&lang=js"
export * from "./ragister_simple.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__